import React from "react";
import { FileText } from "lucide-react";
import { Link } from "react-router-dom";
const Presale = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-black overflow-hidden"
    >
      {/* Desktop Background Only */}
      <div
        className="hidden md:block absolute inset-0"
        style={{
          backgroundImage: "url('/1-Photoroom.png')",
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl -mt-10 md:-mt-16">
        <img
          src="/image.png"
          alt="Logo"
          className="mx-auto mb-8 w-[380px] sm:w-[450px] md:w-[550px] lg:w-[700px]"
        />

        <p className="mt-2 text-white text-base sm:text-lg md:text-2xl font-semibold">
          AI-POWERED TRADING.
          <span className="text-[#c4dc5b]"> REAL REVENUE.</span> REAL VALUE.
        </p>

        <p className="mt-6 max-w-3xl mx-auto text-gray-200 text-sm sm:text-base md:text-lg leading-8">
          Ethra AI is an AI-powered trading ecosystem built on Ethereum,
          designed to generate real on-chain revenue and return sustainable
          value to holders.
        </p>


<div className="flex flex-col sm:flex-row justify-center gap-4 mt-10 w-full max-w-[520px] mx-auto">
  {/* Join Presale */}
  <Link
  to="/presale"
  className="flex w-full sm:w-[250px] h-[64px] sm:h-[72px] items-center justify-center rounded-[10px] border border-[#c8f53a] bg-[linear-gradient(180deg,#b5e003_0%,#9dcb01_100%)] text-[18px] sm:text-[24px] font-bold text-[#1c1c1c] shadow-[inset_0_1px_0_rgba(255,255,255,0.18),0_4px_14px_rgba(157,203,1,0.28)] transition duration-200 hover:brightness-105"
>
  Join Presale
</Link>

  {/* Whitepaper */}
 <a
  href="/ETHRA Whitepaper.pdf"
  target="_blank"
  rel="noopener noreferrer"
  className="w-full sm:w-[250px]"
>
  <button className="flex h-[64px] w-full items-center justify-center gap-3 rounded-[10px] border border-[#c4dc5b] bg-[#0a0a0a] text-[18px] font-medium text-white transition duration-200 hover:bg-[#c4dc5b]/10 sm:h-[72px] sm:text-[24px]">
    <FileText size={22} className="text-[#c4dc5b]" />
    Whitepaper
  </button>
</a>
</div>
      </div>
    </section>
  );
};

export default Presale;